<template>

  <div class="tes-tags-dropdown" @mouseenter="enter" @mouseleave="leave">

    <slot name="selectButton"
          :value="currentTag && currentTag.id() ? currentTag.id() : null"
          :title="currentTag && currentTag.id() ? currentTag.title() : 'Все публикации'">
      <button type="button" class="tes-tags-dropdown__button" @click="visibleTagsList = !visibleTagsList">
        <span class="tes-tags-dropdown__button-text"
              v-if="currentTag && currentTag.id()">#{{ currentTag.title() }}</span>
        <span class="tes-tags-dropdown__button-text" v-else>Все публикации</span>
      </button>
    </slot>

    <nav class="tes-tags-dropdown-wrapper" v-show="visibleTagsList">
      <ul class="tes-tags-dropdown__list">
        <li v-for="tag in tags" @click.prevent="choose(tag)"
            :class="['tes-tags-dropdown__list-item', (currentTag && currentTag.id() === tag.id()) ? 'tes-tags-dropdown__list-item_active' : '']">
          <router-link :to="tag.path()" class="tes-tags-dropdown__list-item-link">{{ tag.title() }}</router-link>
        </li>
      </ul>
    </nav>

  </div>

</template>

<script lang="ts">
import PostTag, {PostTagData, PostTagInterface} from '../../objects/post/PostTag'
import {PaginatorData} from '../../objects/Paginator'

import {ref, defineComponent, onMounted, onServerPrefetch} from 'vue'
import {useStore} from 'vuex'

export default defineComponent({
  name: 'TagsDropDown',
  props: {
    tid: {
      type: [String, Number],
      default: null
    }
  },
  setup(props) {
    const store = useStore()
    const visibleTagsList = ref(false)
    const currentTag = ref(new PostTag({} as PostTagData) as PostTagInterface)
    const tags = ref([] as Array<PostTagInterface>)

    const enter = () => {
      visibleTagsList.value = true
    }

    const leave = () => {
      visibleTagsList.value = false
    }

    const choose = (selTag: PostTagInterface) => {
      currentTag.value = selTag
      visibleTagsList.value = false
    }

    const load = () => {
      return store.dispatch('postsTags/loadDataForTags', {
        props: {},
        paginator: {page: 1, per_page: 999} as PaginatorData,
        sort: null,
        filter: null
      }, {root: true})
        .then(data => {
          data.forEach(tagData => {
            try {
              let tag = new PostTag(tagData as PostTagData)
              if (props.tid && tag.isMyId(props.tid)) {
                currentTag.value = tag
              }
              tags.value.push(tag)
            } catch (e) {
              console.log(e)
            }
          })
        })
        .catch(e => console.log(e))
    }

    onMounted(() => {
      load()
    })

    onServerPrefetch(async () => {
      return await load()
    })

    return {
      tags, currentTag,
      visibleTagsList, enter, leave, choose
    }
  }
})
</script>
